import { NormalizedSupportPolicy } from 'src/graphql/entities/support-policy/support-policy.utils';
import { ESCALATION_URGENCY_CONFIG } from './escalation-utils';
import { POLICY_CATEGORY_ESCALATION } from './policy-constants';

const ESCALATION_URGENCY_ORDER: Record<string, number> = Object.fromEntries(
  ESCALATION_URGENCY_CONFIG.map((config, index) => [config.value, index]),
);

/**
 * Display order shared by the Policies list and the left-nav preview, so the
 * same policy sits in the same place in both. Escalation policies rank by
 * urgency; every other pair compares equal, which a stable sort leaves in the
 * order the query returned.
 */
export const sortPoliciesForDisplay = (
  policies: NormalizedSupportPolicy[],
): NormalizedSupportPolicy[] =>
  [...policies].sort((a, b) => {
    if (
      a.category === POLICY_CATEGORY_ESCALATION &&
      b.category === POLICY_CATEGORY_ESCALATION
    ) {
      return (
        (ESCALATION_URGENCY_ORDER[a.urgencyLevel ?? ''] ?? 999) -
        (ESCALATION_URGENCY_ORDER[b.urgencyLevel ?? ''] ?? 999)
      );
    }
    return 0;
  });
